import Actions                from 'Redux/Actions';
import { LocationRepository } from 'Domain/Repositories';
import { ofType }             from 'redux-observable';
import { from, EMPTY }        from 'rxjs';
import { mergeMap }           from 'rxjs/operators';
import { TEpic }              from 'Redux/Config';

export const findLocationEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.findLocationRequest.type),
    mergeMap(action => {
      const { id } = action.payload;

      if (!id.trim()) {
        return EMPTY;
      }

      return from(
        LocationRepository.findById(id)
          .then((location) => Actions.findLocationSuccess({ location }))
          .catch(error => Actions.findLocationFailure({ error })),
      );
    }),
  );
};
